/**
 * ナビ固定
 */
const stickyNav = () => {
	const nav_position = $('.main-navigation').offset().top;
	let adminBar_height = $('#wpadminbar').height();
	if(!adminBar_height){
		adminBar_height = 0;
	}
	const nav_marginBot = parseInt($('.main-navigation').css('marginBottom'));
	$(window).on('scroll',function() {
		if ($(window).scrollTop() > nav_position + 50) {
			$(".site-menu").css("margin-top", $(".main-navigation").height() + nav_marginBot);
			$(".site-menu").addClass("sticky-header");
			$(".main-navigation").css("top", ($(window).width() > 600) ? adminBar_height : 0);
		} else {
			$(".site-menu").removeClass("sticky-header");
			$(".site-menu").css("margin-top", 0);
			$(".main-navigation").css("top", 0);
		}
	});
};
export default stickyNav;
